import { get, post, http } from './request'
import { utilities } from '@/mixins/js-helpers'
import isNil from 'lodash/isNil'
import omitBy from 'lodash/omitBy'

const documentFormData = doc => utilities.formData(omitBy(doc, isNil))

export default {
  uploadDocument: (payload, success, failure) => post(
    `/api${payload.path}`,
    documentFormData(payload.document),
    success, failure
  ),

  replaceDocument: (doc, success, failure) => post(
    `/api/documents/${doc.id}/replace`,
    documentFormData(doc),
    success, failure
  ),

  deleteDocument: (documentId, success, failure) => post(
    `/api/documents/${documentId}/delete`,
    {},
    success, failure
  ),

  loadRequiredDocuments: (assetId, success, failure) => get(
    `/api/assets/${assetId}/required-documents`,
    success, failure
  ),
}
